import { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

type SeeAllGamesProps = {
  onViewAll?: MouseEventHandler<HTMLDivElement>;
  slidesPerView: number;
};
const GAMES_CARD_WIDTH = 24;

export const SeeAllGames = ({ onViewAll, slidesPerView }: SeeAllGamesProps) => {
  const { t } = useTranslation();

  return (
    <div
      className="seeAllGames x-casinoGameCardImageWrapper"
      onClick={onViewAll}
      style={{
        width: window.innerWidth / slidesPerView - GAMES_CARD_WIDTH
      }}
    >
      <span className="seeAllGames__text">{t('casino.seeAll')}</span>
    </div>
  );
};
